<div class="flex">
  <div class="w-10 flex flex-middle b-b b-col-1 pos-relative"
    [class.is-focus]="isFocus"
    (offClick)="isFocus=false"
    [offClickOff]="!isFocus"
    offClickFilter="search-outlet">
    <input class="input no-focus b-a-0 p-l-0"
      type="text"
      #input
      onclick="this.placeholder=''"
      placeholder="Search"
      [(ngModel)]="term"
      (keyup)="keyup($event)"
      [style.font-size.rem]="1">

    <button class="m-t-2"
      type="button"
      (click)="goToSearch()">
      <i class="icon-search2 p-r-3"
         [style.font-size.px]="36"
         aria-hidden="true"></i>
    </button>
    @if (status && status.busy) {
      <div class="pos-absolute top-0 right-8 bottom-0 flex flex-middle p-a-2 col-13"
        >
        <i class="icon-loading"></i>
      </div>
    }
  </div>
  <button type="button"
    class="z-1 m-t-4 flex flex-top w-2 flex-justify-center"
    (click)="close()">
    <i class="p2 icon-close"></i>
  </button>
</div>
<div
  [ngClass]="productListing?.models?.length ? 'm-t-5' : 'm-t-6'">
  @switch (!!(productListing?.models?.length )) {
    @case (false) {
      @if (popularTerms?.length) {
        <div
          class="m-b-12">
          @if (popularTerms?.length) {
            <h4 class="s1"
            translate>Popular</h4>
          }
          @for (term of popularTerms; track term) {
            <a class="p1 block m-t"
              [routerLink]="['search', term]"
              (click)="close()"
            >{{term}}</a>
          }
        </div>
      }
      @if (contentBlockData?.featuredItems?.length) {
        <div>
          @if (contentBlockData?.title) {
            <p class="s1 p-b"
            >{{contentBlockData.title}}</p>
          }
          @if (contentBlockData?.featuredItems?.length) {
            <carousel class="w-12 featured-carousel"
              [slidesPerView]="2.15"
              [spaceBetween]="16"
              [loop]="false"
              [navigation]="false">
              @for (item of contentBlockData.featuredItems; track item) {
                <ng-template swiperSlide>
                  <href [link]="item.link">
                    <div class="ratio-1-1 overflow-hidden">
                      <local-shell />
                      <img class="rf"
                        [image]="item.image">
                    </div>
                    <p class="s1 p-t-2">{{item.copy}}</p>
                </href>
                </ng-template>
              }
            </carousel>
          }
        </div>
      }
    }
    @case (true) {
      @if (result?.terms) {
        <div class="m-b-12"
          >
          <div>
            @for (term of result.terms | slice: 0 : 5; track trackByTerm($index, term); let isFirst = $first) {
              <a class="block p2 term"
                [class.m-t-5]="!isFirst"
                [routerLink]="term.redirect || ['search', term.barePhrase]"
              [innerHtml]="term.phrase"></a>
            }
          </div>
        </div>
      }
      <div class="flex flex-justify-between m-b p-r">
        <p class="s1"
        translate>Trending Products</p>
        @if (result?.term) {
          <a
            [routerLink]="['search', result.term]"
          class="button-inline s1">{{'View all' | translate}}</a>
        }
      </div>
      @if (productListing?.models) {
        <div class="m-t-2 animation-reveal is-animate search-products p-r"
          cy-quickSearchProductListing
          >
          <div [grid]="2"
            [gridColumnGap]="4"
            [gridRowGap]="4">
            @for (model of productListing.models | slice: 0 : 6; track model) {
              <product [model]="asLocalProduct(model)"
                [gridColumn]="1"
                [smallText]="true"
              [hideSwatches]="true"></product>
            }
          </div>
        </div>
      }
    }
  }
</div>

<search-links class="block m-t-10 m-b-2"></search-links>

<search-banner class="block m-t-5 m-b-24 p-r"
[term]="result?.term"></search-banner>